export default function SearchBar({ query, setQuery }) {
  return (
    <input
      type="text"
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      placeholder="Cerca autore..."
      style={{
        width: "100%",
        padding: "12px 16px",
        fontSize: "18px",
        border: "2px solid #333",
        borderRadius: "8px",
        backgroundColor: "#f2f2f2",
        color: "#000",
        boxSizing: "border-box",
        
      }}
    />
  );
}

